'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z' });

var NoteAdd = function NoteAdd(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

NoteAdd = (0, _pure2.default)(NoteAdd);
NoteAdd.muiName = 'SvgIcon';

exports.default = NoteAdd;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/NoteAdd.js
// module id = 2651
// module chunks = 0